module.exports = __webpack_public_path__ + "static/img/email.eb38f918.png";